import styled from '@emotion/styled';
import { useState } from 'react';
import { ReactComponent as Mobile } from '../images/svgs/mobile.svg';
import { information } from '../information';
import { ButtonPrimary, ButtonSecondary } from './layout/StyledComponents';
import { Link } from 'gatsby';
import { css } from '@emotion/react';

export const AppointmentFormStyled = styled.section`
    color: ${({ theme }) => theme.colors.yellow3};
    a {
        text-decoration: none;
    }
    .top-button {
        margin: 40px auto;
    }
    @media ${({ theme }) => theme.device.tablet} {
        .button-container {
            display: flex;
            justify-content: center;
            gap: 36px;
        }
    }
`;
export const ContactUsStyled = styled.section`
    padding: 32px 0px 64px;
    h2,
    textarea {
        margin-bottom: 24px;
    }
    button {
        width: 100%;
    }

    .main-image {
        margin-bottom: 64px;
        height: 343px;
        border-radius: 15px;
    }

    @media ${({ theme }) => theme.device.laptop} {
        display: flex;
        flex-direction: row;
        gap: 55px;

        justify-content: space-between;
        .main-image {
            width: 548px;
            height: 548px;
        }
        > div + div {
            width: 607px;
        }
    }
    @media ${({ theme }) => theme.device.laptopL} {
        gap: 135px;
        > div + div {
            width: 517px;
        }
    }
`;

const Form = styled.form`
    background: ${({ theme }) => theme.colors.blue1};
    padding: 56px;
    border-radius: 15px;
    fieldset {
        border: none;
        display: flex;
        align-items: center;
        gap: 12px;

        padding: 0;
        margin: 0 0 32px 0;
        label {
            min-width: 110px;
        }

        input {
            outline: none;
        }
        input:focus {
            outline: none;
        }
        p {
            margin: 0;

            padding: 0;
        }
        div {
            gap: 16px;
            display: flex;
            align-items: center;
        }
    }
    .large-header {
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 32px;
        padding-bottom: 12px;
        border-bottom: 2px solid ${({ theme }) => theme.colors.blue3};
    }
    label {
        display: flex;
        flex-direction: column;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        color: ${({ theme }) => theme.colors.gray5};
    }
    .small-header {
        margin-top: 32px;
    }
    fieldset {
        border: none;
        display: flex;
        padding: 0;
        flex-direction: row;
        gap: 32px;
        flex-wrap: wrap;
        margin-bottom: 32px;
    }
    textarea {
        margin-top: 10px;
        margin-bottom: 24px;
    }
    input {
        margin: 10px 0;
    }
    .radio-item {
        display: flex;
        align-items: center;
        label {
            margin-left: 8px;
        }
        input {
            outline: 0px;
        }
    }

    input[type='radio'],
    input[type='checkbox'] {
        outline: none;
        transform: scale(1.7);
    }

    input,
    textarea {
        outline: 1px solid #929ea4;
        border-radius: 5px;
        padding: 15px 24px 15px 12px;
        transition: 0.2s ease-in;
        border-radius: 5px;
        border: none;
        font-size: 12px;
        color: black;
        border-radius: 5px;
    }
    input:-webkit-autofill {
        -webkit-text-fill-color: black;
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        border-radius: 5px;
    }
    input:focus {
        color: ${({ theme }) => theme.colors.gray5};
        outline: 2px solid ${({ theme }) => theme.colors.blue3};
        border-radius: 5px;
    }
    ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
    }

    textarea:focus {
        outline: 2px solid ${({ theme }) => theme.colors.blue3}; /* oranges! yey */
    }

    @media ${({ theme }) => theme.device.laptop} {
        display: flex;
        flex-direction: column;
        fieldset {
            gap: 36px;
            margin: 0 0 16px 0;
        }
        button {
            align-self: center;
            width: 174px;
        }
    }
`;

const AppointmentLinks = styled.div`
    margin: 32px 0 64px;

    > p {
        margin: 24px 0;
        font-weight: 700;
    }

    > div {
        display: flex;
        gap: 32px;
        flex-direction: column;
    }

    @media (min-width: 1030px) {
        > div {
            flex-direction: row;
            max-width: 800px;
        }
    }
`;

export const AppointmentForm: React.FC = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [submitState, setSubmitState] = useState<string>();
    const [clicked, setClicked] = useState<boolean>(false);
    const [radioClicked, setRadioClicked] = useState<boolean>(false);
    const [radioClicked2, setRadioClicked2] = useState<boolean>(false);

    const setInput = (num: number) => {
        if (num === 1) {
            if (radioClicked2) {
                setRadioClicked2(false);
            } else {
                setRadioClicked(clicked => !clicked);
            }
        } else {
            if (radioClicked) {
                setRadioClicked(false);
            } else {
                setRadioClicked2(clicked => !clicked);
            }
        }
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSubmit = async (e: any) => {
        e.preventDefault();
        setSubmitState('submitting');

        const formData = new FormData(e.target);
        const data = [...formData.keys()].reduce((obj, key) => {
            const value = formData.getAll(key).join(', ').trim();
            if (value) {
                obj[key] = value;
            }
            return obj;
        }, {} as Record<string, unknown>);

        await fetch(`https://api.${window.location.host}/contact`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        setSubmitState('submitted');

        e.target.reset();
    };
    return (
        <AppointmentFormStyled>
            <AppointmentLinks>
                <p>Please call to schedule an appointment for Porter branch.</p>
                <ButtonSecondary color="blue" as={Link} to={information.appointmentLink}>
                    Request an appointment
                </ButtonSecondary>
                <p>or request an appointment for a specific location:</p>
                <div>
                    <ButtonSecondary
                        color="blue"
                        as={Link}
                        to={information.santaClarita.appointmentLink}
                    >
                        Santa Clarita
                    </ButtonSecondary>
                    {/* <ButtonSecondary
                        color="blue"
                        as={Link}
                        to={information.porterRanch.appointmentLink}
                    >
                        Porter Ranch
                    </ButtonSecondary> */}
                    <ButtonSecondary
                        color="blue"
                        as={Link}
                        to={information.newHall.appointmentLink}
                    >
                        Newhall
                    </ButtonSecondary>
                </div>
            </AppointmentLinks>
            <div className="button-container">
                <a href={`tel:${information.santaClarita.phone}`}>
                    <ButtonPrimary className="top-button" color="blue">
                        {' '}
                        <Mobile />
                        <span style={{ marginLeft: '11px' }}>
                            SCV - {information.santaClarita.phone}
                        </span>
                    </ButtonPrimary>
                </a>
                <a href={`tel:${information.porterRanch.phone}`}>
                    <ButtonPrimary className="top-button" color="blue">
                        {' '}
                        <Mobile />
                        <span style={{ marginLeft: '11px' }}>
                            NH - {information.porterRanch.phone}
                        </span>
                    </ButtonPrimary>
                </a>

                <a href={`tel:${information.newHall.phone}`}>
                    <ButtonPrimary className="top-button" color="blue">
                        {' '}
                        <Mobile />
                        <span style={{ marginLeft: '11px' }}>PR - {information.newHall.phone}</span>
                    </ButtonPrimary>
                </a>
            </div>

            <Form className={`${clicked && 'submitted'}`} onSubmit={onSubmit}>
                <fieldset
                    css={css`
                        @media (max-width: 767px) {
                            flex-direction: column !important;
                            align-items: flex-start !important;
                        }
                    `}
                >
                    <p>Location*</p>
                    <div>
                        <input
                            type="radio"
                            id="santa-clarita"
                            name="location"
                            value="Santa Clarita"
                            required
                        />
                        <label htmlFor="santa-clarita">Santa Clarita</label>
                    </div>
                    {/* <div>
                        <input
                            type="radio"
                            id="porter-ranch"
                            name="location"
                            value="Porter Ranch"
                            required
                        />
                        <label htmlFor="porter-ranch">Porter Ranch</label>
                    </div> */}

                    <div>
                        <input
                            type="radio"
                            id="new-hall"
                            name="location"
                            value="Newhall"
                            required
                        />
                        <label htmlFor="new-hall">Newhall</label>
                    </div>
                </fieldset>
                <ul>
                    <li>Santa Clarita - taking DENTICAL and ALL PPO insurances</li>
                    <li>Porter Ranch - taking ALL PPO insurances</li>
                </ul>
                <p className="large-header">Patient Information</p>
                <label htmlFor="name">
                    Full Name*
                    <input placeholder="John Doe" type="text" name="name" id="name" required />
                </label>
                <label htmlFor="email">
                    Email*
                    <input
                        placeholder="johndoe@email.com"
                        type="email"
                        name="email"
                        id="email"
                        required
                    />
                </label>
                <label htmlFor="phone">
                    Phone
                    <input
                        placeholder="(123) 456 6789"
                        type="tel"
                        name="phone"
                        id="phone"
                        required
                    />
                </label>
                <div>
                    <p className="small-header">Are you a current patient?</p>
                    <fieldset>
                        <div className="radio- item">
                            <input
                                type="radio"
                                value="current-patient-yes"
                                id="current-patient-yes"
                                name="current-patient"
                            />
                            <label htmlFor="current-patient-yes">Yes</label>
                        </div>
                        <div className="radio-item">
                            <input
                                type="radio"
                                value="current-patient-no"
                                id="current-patient-no"
                                name="current-patient"
                            />
                            <label htmlFor="current-patient-no">No</label>
                        </div>
                    </fieldset>
                </div>
                <div>
                    <p className="large-header">Patient Availability</p>
                    <p>
                        <b>Please select all that apply</b>
                    </p>
                    <p>Preferred day(s) of the week for an appointment?</p>
                    <fieldset>
                        <div className="radio-item">
                            <input
                                type="checkbox"
                                value="available-anyday"
                                id="available-anyday"
                                name="available-anyday"
                            />
                            <label htmlFor="currentPatientNo">Any Day</label>
                        </div>
                        <div className="radio-item">
                            <input
                                type="checkbox"
                                value="available-monday"
                                id="available-monday"
                                name="available-monday"
                            />
                            <label htmlFor="currentPatientNo">Monday</label>
                        </div>
                        <div className="radio-item">
                            <input
                                type="checkbox"
                                value="available-tuesday"
                                id="available-tuesday"
                                name="available-tuesday"
                            />
                            <label htmlFor="available-tuesday">Tuesday</label>
                        </div>
                        <div className="radio-item">
                            <input
                                type="checkbox"
                                value="available-wednesday"
                                id="available-wednesday"
                                name="available-wednesday"
                            />
                            <label htmlFor="available-wednesday">Wednesday</label>
                        </div>
                        <div className="radio-item">
                            <input
                                type="checkbox"
                                value="available-thursday"
                                id="available-thursday"
                                name="available-thursday"
                            />
                            <label htmlFor="available-thursday">Thursday</label>
                        </div>
                        <div className="radio-item">
                            <input
                                type="checkbox"
                                value="available-friday"
                                id="available-friday"
                                name="available-friday"
                            />
                            <label htmlFor="available-friday">Friday</label>
                        </div>
                    </fieldset>
                    <p className="small-header">Preferred time(s) for an appointment?</p>
                    <fieldset>
                        <div className="radio-item">
                            <input
                                type="checkbox"
                                value="preffered-time-any"
                                id="preffered-time-any"
                                name="preffered-time-any"
                            />
                            <label htmlFor="preffered-time-any">Any Time</label>
                        </div>
                        <div className="radio-item">
                            <input
                                type="checkbox"
                                value="preffered-time-morning"
                                id="preffered-time-morning"
                                name="preffered-time-morning"
                            />
                            <label htmlFor="available-">Morning</label>
                        </div>
                        <div className="radio-item">
                            <input
                                type="checkbox"
                                value="preffered-time-noon"
                                id="preffered-time-noon"
                                name="preffered-time-noon"
                            />
                            <label htmlFor="preffered-time-noon">Noon</label>
                        </div>
                        <div className="radio-item">
                            <input
                                type="checkbox"
                                value="preffered-time-afternoon"
                                id="preffered-time-afternoon"
                                name="preffered-time-afternoon"
                            />
                            <label htmlFor="preffered-time-afternoon">Afternoon</label>
                        </div>
                    </fieldset>
                </div>
                <p className="large-header">Reason For Visit</p>
                <label htmlFor="message">
                    Please describe the nature of your appointment?
                    <textarea
                        name="message"
                        id="message"
                        required
                        placeholder="e.g., consultation, check-up, etc."
                    />
                </label>
                <p style={{ fontSize: '14px', marginBottom: '24px' }}>
                    Note: Messages sent using this form are not considered private. Please contact
                    our office by telephone if sending highly confidential or private information.
                </p>
                <ButtonPrimary
                    type="submit"
                    disabled={submitState === 'submitting'}
                    color="blue"
                    fill
                >
                    {submitState === 'submitting' ? 'Sending...' : 'Submit'}
                </ButtonPrimary>
                <p
                    style={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                        transition: 'opacity .2s ease-in',
                        opacity: `${submitState === 'submitted' ? '1' : '0'}`,
                    }}
                >
                    Thank You! Your message has been sent
                </p>
            </Form>
        </AppointmentFormStyled>
    );
};
